<template>
    <div class="box-shadow-inside box-background box-ssjc mt20">
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">月度统计</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div id="echart01" class="chart01" :style="{height: '430px'}"></div>
    </div>
</template>

<script>

    import xhr from "../../../utils/xhr";

    export default {
        name: 'MonitorEchartsOne',
        data() {
            return {
                nowDate: "",
                financingLast6MonthsList: []
            }
        },
        computed: {
            yearMonthList() {
                return [... new Set(this.financingLast6MonthsList.map(item=>item.fi__year + '-' + item.fi__month).sort((a ,b) => {
                    return Number(this.$moment(a)) - Number( this.$moment(b) )
                }))]
            }
        },
        mounted() {
            this.getFinancingLast6MonthsList();
        },
        methods:{
            echart01(){
                let myChart = this.$echarts.init(document.getElementById('echart01'))
                const option = {
                    // color: ['#50f83f','#ff29d4','#3f8cf8','#e88c45'],
                    tooltip: {
                        trigger: 'axis',
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        }
                    },
                    grid:{
                        left:100,
                        right:60,
                        top: 120,
                        bottom:60,
                    },
                    legend: {
                        data: [ '自营笔数', '自营金额', '助贷笔数', '助贷金额'],
                        top: '15',
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        },
                        itemGap:  50

                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.yearMonthList,
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#96dcff',
                                    fontSize:24,
                                },
                                formatter: val => {
                                    return this.$moment(val).format('MM月')
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: '#96dcff',
                                    width:'2'
                                }
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '金额(万元)',
                            nameTextStyle:{
                                fontSize:24,
                                padding:10
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#96dcff',
                                    fontSize:24,
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: '#96dcff',
                                    width:'2'
                                }
                            },
                        },
                        {
                            type: 'value',
                            name: '笔数',
                            nameTextStyle:{
                                fontSize:24,
                                padding:10
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#96dcff',
                                    fontSize:24,
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: '#96dcff',
                                    width:'2'
                                }
                            },
                        }
                    ],
                    series: [
                        {
                            name: '自营笔数',
                            type: 'line',
                            smooth: true,
                            yAxisIndex: 1,
                            data: this.yearMonthList.map(yearMonth=>{
                                let year = yearMonth.split('-')[0]||''
                                let month = yearMonth.split('-')[1]||''

                                return (this.financingLast6MonthsList.find(item=>item.fi__year === year && item.fi__month === month && item.fi__transactionTypeCode === 'HFI')||{}).fi__counts||0
                            })
                        },
                        {
                            name: '助贷笔数',
                            type: 'line',
                            smooth: true,
                            yAxisIndex: 1,
                            data: this.yearMonthList.map(yearMonth=>{
                                let year = yearMonth.split('-')[0]||''
                                let month = yearMonth.split('-')[1]||''

                                return (this.financingLast6MonthsList.find(item=>item.fi__year === year && item.fi__month === month && item.fi__transactionTypeCode === 'LFI')||{}).fi__counts||0
                            })
                        },
                        {
                            name: '自营金额',
                            type: 'bar',
                            yAxisIndex: 0,
                            data: this.yearMonthList.map(yearMonth=>{
                                let year = yearMonth.split('-')[0]||''
                                let month = yearMonth.split('-')[1]||''

                                return (this.financingLast6MonthsList.find(item=>item.fi__year === year && item.fi__month === month && item.fi__transactionTypeCode === 'HFI')||{}).fi__values||0
                            })
                        },
                        {
                            name: '助贷金额',
                            type: 'bar',
                            yAxisIndex: 0,
                            data: this.yearMonthList.map(yearMonth=>{
                                let year = yearMonth.split('-')[0]||''
                                let month = yearMonth.split('-')[1]||''

                                return (this.financingLast6MonthsList.find(item=>item.fi__year === year && item.fi__month === month && item.fi__transactionTypeCode === 'LFI')||{}).fi__values||0
                            })
                        }
                    ]
                }
                myChart.setOption(option)
                tools.loopShowTooltip(myChart, option, {loopSeries: true, interval: 4000}); // 使用循环轮播插件
            },
            getFinancingLast6MonthsList: function () {
                xhr.getFinancingLast6MonthsList(0, ({data}) => {
                    if (data.status === 'success') {
                        this.financingLast6MonthsList = (data.data || []).map(item=> {
                            item.fi__values = Number((Number(item.fi__values)||0) / 10000 ) || 0
                            return item
                        })

                        this.echart01()
                    }
                })

            }
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorEchartsOne.vue